import { Icon } from '@wordpress/components'
import { check } from '@wordpress/icons'

export const Check = ({ condition = false }) => {
  // TODO:
  const colors = {
    BLUE:
      getComputedStyle(document.body).getPropertyValue(
        '--wp--preset--color--vivid-cyan-blue'
      ) || '#0693e3',
    GRAY:
      getComputedStyle(document.body).getPropertyValue(
        '--wp--preset--color--cyan-bluish-gray'
      ) || '#abb8c3',
    RED:
      getComputedStyle(document.body).getPropertyValue(
        '--wp--preset--color--vivid-red'
      ) || '#cf2e2e',
  }

  return (
    <span
      style={{
        fill: condition ? colors.BLUE : colors.GRAY,
        color: condition ? colors.BLUE : colors.GRAY,
      }}
    >
      <Icon icon={check} />
    </span>
  )
}
